import { useState } from 'react';
import useApiContext from '../../../hooks/useApiContext';

interface UseFileUploadResult {
  uploadFile: (file: File) => Promise<string>;
  isUploading: boolean;
  error: string | null;
}

export const useFileUpload = (): UseFileUploadResult => {
  const { mediaRepository } = useApiContext();
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const uploadFile = async (file: File): Promise<string> => {
    setIsUploading(true);
    setError(null);

    try {
      // Create FormData for file upload
      const formData = new FormData();
      formData.append('file', file);

      // Upload using MediaRepository
      const mediaResponse = await mediaRepository.uploadFileImage(formData);

      // Return the appropriate image URL
      // Use w1024 for good quality while keeping file sizes reasonable
      return mediaResponse.w1024 || mediaResponse.original;
    } catch (err: any) {
      const errorMessage = err.message || 'Failed to upload image';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setIsUploading(false);
    }
  };

  return {
    uploadFile,
    isUploading,
    error,
  };
};
